<div class="card border-0 mb-5" rt="buy-only-machine-card" #card>
  <div class="card-image" [class.show-extra-info]="showExtraInfo">
    <swiper [config]="imageSwipeConfig" *ngIf="cardThumbnails.length > 0 && !imageLoadError">
      <div *ngFor="let image of cardThumbnails; let i = index">
        <a
          *ngIf="shouldShowImage(i)"
          rt="buy-only-machine-card-img"
          [routerLink]="[machineDetailsUrl]"
          [queryParams]="{ id: machine.id }"
          [commonEventTracker]="MarketTrackingEvents.SearchResult.Click"
          [properties]="{ inventoryId: machine.id }"
          (click)="$event.stopPropagation()"
        >
          <img
            class="card-img-top"
            *ngIf="cardThumbnails.length == 1"
            [class.blur]="showExtraInfo"
            [src]="baseImagePath + image"
            [alt]="machine.make + ' ' + machine.model"
            (error)="onImageError(i)"
          />
          <img
            class="card-img-top swiper-lazy"
            *ngIf="cardThumbnails.length != 1"
            [class.blur]="showExtraInfo"
            [attr.data-src]="baseImagePath + image"
            [attr.alt]="machine.make + ' ' + machine.model"
            (error)="onImageError(i)"
          />
        </a>
      </div>
    </swiper>

    <ng-container *ngIf="imageLoadError || machine.thumbnails?.length == 0">
      <a
        rt="buy-only-machine-card-img"
        [routerLink]="[machineDetailsUrl]"
        [queryParams]="{ id: machine.id }"
        [commonEventTracker]="MarketTrackingEvents.SearchResult.Click"
        [properties]="{ inventoryId: machine.id }"
        [state]="filteredAttachments"
        (click)="$event.stopPropagation()"
      >
        <div class="card-img-top d-flex align-items-center justify-content-center text-center p-4" style="min-height: 300px; background-color: #f5f5f5">
          <p class="font-weight-light text-muted mb-0">We are sorry, machine images are currently unavailable. Rest assured all listings are 100% accurate.</p>
        </div>
      </a>
    </ng-container>

    <div class="share-icon-main-container cursor-pointer" *ngIf="!showExtraInfo" (click)="$event.stopPropagation(); share()">
      <div class="icon-share-container">
        <i class="icon-share text-white"></i>
      </div>
    </div>

    <div class="top-owner-container" [class.extra-blur]="showExtraInfo" *ngIf="machine.isTopOwner">
      <common-top-owner [showTopOwner]="machine.isTopOwner"></common-top-owner>
    </div>

    <div class="one-day-shipping-container" [class.extra-blur]="showExtraInfo" *ngIf="machine.inventoryGroupId">
      <common-top-owner [showTopOwner]="true" icon="icon-truck-fill" theme="light" text="1 day shipping"></common-top-owner>
    </div>
  </div>

  <!-- Start of extra info -->
  <div class="extra-info br-5 pt-3 t px-3 text-white w-100" [@fadeInOut] [style.height]="extraInfoHeight" *ngIf="showExtraInfo">
    <div class="info-icon-main-container cursor-pointer" (click)="hideExtraInfo()">
      <div class="icon-info-container">
        <i class="icon-cancel text-white fs-26"></i>
      </div>
    </div>
    <swiper [config]="extraInfoConfig" [(index)]="extraInfoIndex">
      <!-- Removed Pricing Options and Rental Purchase Option (RTO) slides -->
    </swiper>
  </div>
  <!-- End of extra info -->

  <div class="px-2" [class.blur]="showExtraInfo">
    <div class="d-flex mt-2 align-items-start machine-info-row">
      <div class="mt-2 machine-details">
        <div class="machine-heading">
          <p class="teko machine-title mb-0">{{ machine.make }} {{ machine.model }}</p>
          <p class="font-weight-light machine-subtitle mb-0">{{ machine.year }} {{ machine.primaryType }}</p>
        </div>
        <p class="font-weight-light fs-13 machine-meta mb-0">
          <ng-container *ngIf="(machine.usageAbbreviation || 'hrs') !== 'none'">
            {{ machine.usage | number: "1.0-0" }} {{ machine.usageAbbreviation || "hrs" }} <span class="mx-1">|</span>
          </ng-container>

          {{ machine?.location | location: "cityState":false }}
        </p>
        <p class="font-weight-light fs-13 machine-meta mb-0" *ngIf="machine.distanceFromUser">{{ machine.distanceFromUser }} miles away</p>

        <!-- Financing Available Badge -->
        <div class="d-inline-flex flex-wrap">
          <div
            class="alert alert-warning financing-badge fs-13 p-1 font-weight-light d-flex align-items-center mb-0 cursor-pointer"
            role="alert"
            *ngIf="machine.buyItNowEnabled || machine.rpoEnabled"
            (click)="navigateToFinancing($event)"
          >
            <i class="icon-earnings mr-1"></i> Financing Available
          </div>
        </div>
      </div>

      <div class="ml-auto font-weight-light">
        <div class="d-flex flex-column align-items-end">
          <div class="alert text-success fs-15 pb-1 pr-1 font-weight-light d-flex align-items-center mb-0" role="alert">
            <i class="icon-notification1 mr-1"></i> Unavailable for rent
          </div>
        </div>
      </div>
    </div>

    <div class="mt-1" *ngIf="machine.relatedAttachments.length > 0">
      <span
        *ngFor="let attachment of machine.relatedAttachments"
        class="badge badge-pill fs-13 p-1 font-weight-light mr-2 mb-1 px-2"
        [ngClass]="{ 'badge-secondary': attachment.selected, 'badge-outline-secondary': !attachment.selected }"
      >
        <i class="icon-earnings text-primary mr-2"></i>
        <i class="icon-checkmark mr-2" *ngIf="attachment.selected" style="color: #f0b823"></i>
        {{ attachment.displayName }}<ng-container *ngIf="attachment.buyItNowPrice"> —
          <ng-container *ngIf="!machine.buyItNowPricingOnRequest">{{ attachment.buyItNowPrice | currency: "USD":"symbol":"1.0-0" }}</ng-container>
          <ng-container *ngIf="machine.buyItNowPricingOnRequest">Price on Request</ng-container>
        </ng-container>
      </span>
    </div>

    <!-- Button Group -->
    <div class="d-flex flex-column justify-content-center mt-2">
      <!-- Details Button -->
      <a
        rt="machine-card-view-details"
        class="btn btn-outline-dark bg-white text-dark d-flex justify-content-center align-items-center py-0 w-100 mb-2"
        [routerLink]="[machineDetailsUrl]"
        [queryParams]="{ id: machine.id }"
        [commonEventTracker]="MarketTrackingEvents.SearchResult.Click"
        [properties]="{ inventoryId: machine.id }"
        [state]="filteredAttachments"
      >
        <div class="fs-24 teko">Details</div>
      </a>

      <!-- Buy it Now Button -->
      <a
        target="_blank"
        [href]="financingUrl()"
        class="btn btn-outline-dark btn-add-to-cart d-flex align-items-center justify-content-center py-0 w-100"
      >
        <i class="icon-earnings fs-30 text-primary mr-2"></i>
        <div class="fs-24 teko">
          <ng-container *ngIf="listingPrice.buyItNow === 'price'">Buy it Now for {{ listingPrice.buyItNowPrice | currency: "USD":"symbol":"1.0-0" }}</ng-container>
          <ng-container *ngIf="listingPrice.buyItNow === 'on-request'">Buy It Now — Price on Request</ng-container>
          <ng-container *ngIf="listingPrice.buyItNow === 'unlabeled' || listingPrice.buyItNow === 'hidden'">Buy it Now</ng-container>
        </div>
      </a>
    </div>
  </div>
</div>
